/**
 * Componente Container
 * Contenedor responsivo con ancho máximo y padding
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Contenedor con ancho máximo centrado
 * @param {Object} props - Propiedades del componente
 * @param {ReactNode} props.children - Contenido del contenedor
 * @param {string} props.className - Clases CSS adicionales
 * @param {boolean} props.fluid - Si es true, ocupa todo el ancho disponible
 * @returns {JSX.Element} Componente contenedor
 */
const Container = ({ children, className = '', fluid = false }) => {
  const baseClasses = 'mx-auto px-4 sm:px-6 lg:px-8 xl:px-12';
  const widthClasses = fluid ? 'w-full' : 'max-w-[1400px]';

  return (
    <div className={`${baseClasses} ${widthClasses} ${className}`}>
      {children}
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fluid: PropTypes.bool,
};

export default Container;
